 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"0a52a9f","1":"6da3dbc","2":"3c2d09b","3":"fd0dca1","4":"6f89312","5":"d04a5bb","6":"b2ab7a9","7":"ddcff4e","8":"e204e1b","9":"cd04e74","10":"2315bf7","11":"b97c78d","12":"fd618d3","13":"3deb320","14":"c6424c5","15":"778ebbf","16":"e95433d","17":"a65dcd0","18":"67d86d0","19":"4c07e85","20":"b9fa99a","21":"5e81bed","22":"32050eb","23":"981e888","24":"b9e245b","25":"c226f3d","26":"d8b2c00","27":"5df4423","28":"e45d4af","29":"4d2aa49","30":"e841c2d","31":"3586b30","32":"5586b89","33":"38f4582","34":"fb9548b","35":"6debddc","36":"9aef96b","37":"c052b5c","38":"719a76c","39":"0b115c2","40":"022f10f","41":"50c0ce9","42":"a23b341","43":"7af4378","44":"eef9fce","45":"213969a","46":"041949e","47":"6b2c876","48":"3cfe208","49":"a6ecb54","50":"23482e9","51":"dc16c3e","52":"1b80781","53":"c7e53e3","54":"4262a08","55":"951ff6c","56":"152c773","57":"d1fc49e","58":"9091aea","59":"a7aba8b","60":"9fdc3dc","61":"25b9b01","62":"10f2335","63":"13f2a75","64":"781d8da","65":"5e19d90","66":"867dd3e","67":"c4c7f48","68":"1641856","69":"e3113f4","70":"91d3157","71":"1e1eb71","72":"b43d954","73":"e28c7a1","74":"9f0ef35","75":"7cf70c9","76":"55c9719","77":"485431e","78":"3c73e60","79":"823e258","80":"39100d0","81":"529990d","82":"9706cf9","83":"93a822a","84":"4ea58bd","85":"a2606f0","86":"1b6e6c4","87":"38eddc8","88":"7be0867","89":"c04da66","90":"4132300","91":"b46d64c","92":"9f5ce5e","93":"bf6dfc7","94":"b3588af","95":"198d966","96":"036bbf6","97":"ed9ab6f","98":"8b59d97","99":"7bfcf88","100":"a31d13c","101":"2dc07e3","102":"a14046a","103":"452d999","104":"d5a1cbb","105":"e4ffef9","106":"773fe54","107":"961aaa5","108":"42cd8ac","109":"d92fbfe","110":"955c7f7","111":"ee5a8a4","112":"f7f5a5a","113":"f475aa7","114":"90c69db","components/delay-hydration":"80d5370","components/hot-accordion":"a3eb6d5","components/hot-accordion-item":"e8a543f","components/hot-app-store-button":"2d43ef5","components/hot-iframe-sso":"a11bf5c","components/hot-organic-accordion":"1b8acc9","components/hot-organic-accordion-item":"81f4eb8","components/hot-organic-accordion-item-custom":"3a05de0","components/hot-organic-button":"18d1895","components/hot-tag":"01f40fe","components/hot-video":"3bcccf9","components/hydration-status":"26647f7","lang-es-co.js":"7dc0f3d","lang-es-es.js":"a9bb93d","lang-es-mx.js":"66022cf","lang-es.js":"89ddd29","lang-fr.js":"f5a5316","lang-it.js":"718c17e","lang-jp.js":"b677998","lang-pt-br.js":"702bb46","pages/404":"535b9bf","pages/about":"5a9af77","pages/affiliates":"f2d7077","pages/club":"193f7a8","pages/hotmart-app":"f45d3e8","pages/is-hotmart-for-me":"157f67e","pages/lp-producer":"056c53b","pages/members-area/index/pages/members-area/paid-media":"8cff555","pages/members-area/index":"09fa9ea","pages/members-area/paid-media":"f9df50c","pages/members-area/thank-you":"598967f","pages/payments":"dc2621f","pages/pricing":"302de71","pages/producers":"5dbf1b8","pages/sitemap":"0c6b568","pages/solutions":"22a088a","pages/tour/_id":"6546d8b","pages/tour/index":"fbdb5ca","vendors/pages/index":"1f67bdf","pages/index":"82250d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"12":1,"13":1,"14":1,"15":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"113":1,"components/hot-accordion":1,"components/hot-accordion-item":1,"components/hot-app-store-button":1,"components/hot-iframe-sso":1,"components/hot-organic-accordion":1,"components/hot-organic-accordion-item":1,"components/hot-organic-accordion-item-custom":1,"components/hot-organic-button":1,"components/hot-tag":1,"components/hot-video":1,"pages/affiliates":1,"pages/club":1,"pages/hotmart-app":1,"pages/lp-producer":1,"pages/members-area/index/pages/members-area/paid-media":1,"pages/members-area/index":1,"pages/members-area/thank-you":1,"pages/pricing":1,"pages/solutions":1,"pages/index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"bc92dc3","1":"ac54777","2":"cbabb86","3":"cdcdb3d","4":"66645f7","5":"d8d62a2","6":"351380d","7":"19989c6","8":"4007b79","9":"c8112fa","10":"54a8347","11":"31d6cfe","12":"ed7a8c4","13":"75e67e8","14":"c042bc4","15":"39c5a44","16":"31d6cfe","17":"be41761","18":"02946a2","19":"be814ea","20":"c32563d","21":"241ffb1","22":"e863632","23":"4188e7c","24":"5600e18","25":"0f3ddc3","26":"d70f182","27":"e2c2f75","28":"fdade79","29":"a04a862","30":"d75264e","31":"93aff2e","32":"ad26373","33":"80e4f98","34":"a020706","35":"eb8103c","36":"4468057","37":"08fe6d2","38":"064c4b1","39":"09c7f16","40":"ac4ef9f","41":"f75b75e","42":"689759f","43":"e48ac1d","44":"f3e0ea2","45":"99d4bdc","46":"00f530c","47":"ab0e1fc","48":"26aad64","49":"56e0dd1","50":"727ff82","51":"fef25de","52":"5c5ce5e","53":"6e1d829","54":"f435948","55":"de69fb0","56":"dd2d0c8","57":"62e0b0c","58":"34f525f","59":"30aa5b5","60":"72bfb9d","61":"b5d48e2","62":"f759bb7","63":"56abd46","64":"5535ef7","65":"df1bd4f","66":"c1e4f65","67":"3f9d89d","68":"3f53998","69":"047da8f","70":"61d5c1c","71":"8e580b9","72":"ab64f81","73":"66645f7","74":"77a873c","75":"e4f3dcf","76":"f52ea8e","77":"b54ff1c","78":"5670dd5","79":"a5c4bdf","80":"848597c","81":"a2a2e07","82":"5a61a94","83":"8945d3a","84":"96b37b0","85":"972a3e4","86":"01bb85e","87":"9b60878","88":"85f5fcb","89":"b82956b","90":"77dcec5","91":"9e3df9d","92":"885540e","93":"d194fec","94":"76d7586","95":"ae59dbb","96":"bedc643","97":"fe5f52e","98":"df95389","99":"0a0f1f7","100":"80e10ea","101":"9b20e99","102":"f0d8317","103":"443998a","104":"573a98f","105":"d8beaf2","106":"6223a7e","107":"9a60522","108":"fcca9e1","109":"1d007c1","110":"f68e80c","111":"da26f13","112":"e22d49c","113":"11a0668","114":"31d6cfe","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-app-store-button":"935e4c5","components/hot-iframe-sso":"d66ab2d","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe","vendors/pages/index":"31d6cfe","pages/index":"1455007"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"bc92dc3","1":"ac54777","2":"cbabb86","3":"cdcdb3d","4":"66645f7","5":"d8d62a2","6":"351380d","7":"19989c6","8":"4007b79","9":"c8112fa","10":"54a8347","11":"31d6cfe","12":"ed7a8c4","13":"75e67e8","14":"c042bc4","15":"39c5a44","16":"31d6cfe","17":"be41761","18":"02946a2","19":"be814ea","20":"c32563d","21":"241ffb1","22":"e863632","23":"4188e7c","24":"5600e18","25":"0f3ddc3","26":"d70f182","27":"e2c2f75","28":"fdade79","29":"a04a862","30":"d75264e","31":"93aff2e","32":"ad26373","33":"80e4f98","34":"a020706","35":"eb8103c","36":"4468057","37":"08fe6d2","38":"064c4b1","39":"09c7f16","40":"ac4ef9f","41":"f75b75e","42":"689759f","43":"e48ac1d","44":"f3e0ea2","45":"99d4bdc","46":"00f530c","47":"ab0e1fc","48":"26aad64","49":"56e0dd1","50":"727ff82","51":"fef25de","52":"5c5ce5e","53":"6e1d829","54":"f435948","55":"de69fb0","56":"dd2d0c8","57":"62e0b0c","58":"34f525f","59":"30aa5b5","60":"72bfb9d","61":"b5d48e2","62":"f759bb7","63":"56abd46","64":"5535ef7","65":"df1bd4f","66":"c1e4f65","67":"3f9d89d","68":"3f53998","69":"047da8f","70":"61d5c1c","71":"8e580b9","72":"ab64f81","73":"66645f7","74":"77a873c","75":"e4f3dcf","76":"f52ea8e","77":"b54ff1c","78":"5670dd5","79":"a5c4bdf","80":"848597c","81":"a2a2e07","82":"5a61a94","83":"8945d3a","84":"96b37b0","85":"972a3e4","86":"01bb85e","87":"9b60878","88":"85f5fcb","89":"b82956b","90":"77dcec5","91":"9e3df9d","92":"885540e","93":"d194fec","94":"76d7586","95":"ae59dbb","96":"bedc643","97":"fe5f52e","98":"df95389","99":"0a0f1f7","100":"80e10ea","101":"9b20e99","102":"f0d8317","103":"443998a","104":"573a98f","105":"d8beaf2","106":"6223a7e","107":"9a60522","108":"fcca9e1","109":"1d007c1","110":"f68e80c","111":"da26f13","112":"e22d49c","113":"11a0668","114":"31d6cfe","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-app-store-button":"935e4c5","components/hot-iframe-sso":"d66ab2d","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe","vendors/pages/index":"31d6cfe","pages/index":"1455007"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/app-hotmart/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
